<template>
	<div>
		<v-stepper v-model="stepper" vertical>
			<v-stepper-step :complete="stepper > 1" step="1">Enter your email address</v-stepper-step>
			<v-stepper-content step="1">
				<ValidationObserver ref="email" v-slot="{ invalid, validated, passes }">
					<v-form>
						<ValidationProvider v-slot="{ errors }" name="email" rules="required|email">
							<v-text-field
								v-model="user"
								:error-messages="errors"
								class="remove-padding"
								placeholder="Email"
								autofocus
								filled
								@keyup.enter="passes(submit)"
							/>
						</ValidationProvider>

						<div v-if="errs.length" class="error-callback">
							<ul>
								<li v-for="error in errs" :key="error">{{ error }}</li>
							</ul>
						</div>
						<div class="d-flex justify-space-around">
							<v-row class="reset-control">
								<v-col cols="12" xl="12" class="top-row-align">
										<v-btn
											color="primary"
											:loading="loading"
											:disabled="loading || invalid || !validated"
											@click.prevent="passes(submit)"
										>Send Verification Code</v-btn>
								</v-col>

								<v-col cols="12" xl="12" class="bottom-row-align">
									<a
										class="white--text existing-code"
										color="third"
										text
										:disabled="invalid || !validated"
										@click="passes(stepper = 2)"
									>
										I already have a verification code
									</a>
								</v-col>
							</v-row>
						
							
						</div>
					</v-form>
				</ValidationObserver>
			</v-stepper-content>

			<v-stepper-step :complete="stepper > 2" step="2">Reset password with verification code</v-stepper-step>
			<v-stepper-content step="2">
				<p
					v-if="destination"
				>{{`We have sent a verification code to ${destination}. Please check your ${attributeName}.`}}</p>
				<ValidationObserver ref="verify" v-slot="{ invalid, validated, passes }">
					<v-form autocomplete="off">
						<ValidationProvider v-slot="{ errors }" name="code" rules="required|min:6">
							<v-text-field
								v-model="code"
								:error-messages="errors"
								placeholder="Verification Code"
								class="remove-padding"
								:type="'password'"
								autocomplete="chrome-off"
								min="6"
								required
							/>
						</ValidationProvider>
						<ValidationProvider
							v-slot="{ errors }"
							name="password"
							rules="required|min:12|verify_password"
							vid="newPassword"
						>
							<v-text-field
								v-model="password"
								:error-messages="errors"
								placeholder="New password"
								min="12"
								:type="e1 ? 'password' : 'text'"
								autocomplete="chrome-off"
								counter
							>
								<template v-slot:append>
									<eye-icon v-if="e1" style="cursor: pointer;" @click="() => (e1 = !e1)"></eye-icon>
									<eyeoff-icon v-else style="cursor: pointer;" @click="() => (e1 = !e1)"></eyeoff-icon>
								</template>
							</v-text-field>
						</ValidationProvider>
						<ValidationProvider
							v-slot="{ errors }"
							name="confirmPassword"
							rules="required|min:12|verify_password|confirmed:newPassword"
						>
							<v-text-field
								v-model="confirmPassword"
								placeholder="Confirm your password"
								:error-messages="errors"
								:type="e1 ? 'password' : 'text'"
								counter
								@keyup.enter="passes(resetPassword)"
							>
								<template v-slot:append>
									<eye-icon v-if="e1" style="cursor: pointer;" @click="() => (e1 = !e1)"></eye-icon>
									<eyeoff-icon v-else style="cursor: pointer;" @click="() => (e1 = !e1)"></eyeoff-icon>
								</template>
							</v-text-field>
						</ValidationProvider>
						<div v-if="errs.length" class="error-callback">
							<ul>
								<li v-for="error in errs" :key="error">{{ error }}</li>
							</ul>
						</div>
					</v-form>
					<v-btn
						class="white--text"
						color="third"
						:loading="loading"
						:disabled="invalid || !validated || loading"
						@click.prevent="passes(resetPassword)"
					>Reset password</v-btn>
				</ValidationObserver>
			</v-stepper-content>
		</v-stepper>
		<v-layout justify-end align-content-end class="mt-2 return-login">
			<a href @click.prevent="returnLogin">Return to Login</a>
		</v-layout>
	</div>
</template>

<script>
	import Auth from "@aws-amplify/auth";
	export default {
		props: {
			email: {
				type: String,
				default: ""
			}
		},
		data: () => ({
			errs: [],
			loading: false,
			stepper: 1,
			e1: true,
			user: "",
			code: "",
			attributeName: "",
			destination: "",
			password: "",
			confirmPassword: ""
		}),
		watch: {
			user: function() {
				this.clearErrors();
			},
			code: function() {
				this.clearErrors();
			},
			password: function() {
				this.clearErrors();
			},
			confirmPassword: function() {
				this.clearErrors();
			}
		},
		mounted() {
			this.user = this.email || "";
		},
		methods: {
			submit() {
				this.loading = true;
				Auth.forgotPassword(this.user)
					.then(data => {
						this.attributeName = data.CodeDeliveryDetails.AttributeName;
						this.destination = data.CodeDeliveryDetails.Destination;
						this.stepper = 2;
						this.loading = false;
					})
					.catch(err => {
						this.loading = false;
						this.errs.push(err.message);
					});
			},
			resetPassword() {
				this.loading = true;
				Auth.forgotPasswordSubmit(this.user, this.code, this.password)
					.then(() => {
						this.loading = false;
						this.$emit("auth-state", {
							type: "confirmCode"
						});
					})
					.catch(err => {
						this.loading = false;
						this.errs.push(err.message);
					});
			},
			clearErrors() {
				if (this.errs.length > 0) {
					this.errs = [];
				}
			},
			returnLogin() {
				this.$emit("auth-state", {
					type: "Login"
				});
			}
		}
	};
</script>

<style lang="scss" scoped>

		.reset-control {
			padding-top: 1em;
			.top-row-align {
				text-align: left;
			}

			.bottom-row-align {
				text-align: left;
			}

			@media only screen and (max-width: 1903px) {
				.top-row-align {
					text-align: left;
				}

				.bottom-row-align {
					text-align: left;
				}
			}
		}
	
	.existing-code {
		text-transform: initial;
		font-size: .875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: .0071428571em;
		color: rgb(19, 41, 75) !important;
		text-decoration: underline;
		text-align: left;
	}
	.return-login {
		a {
			color: white !important;
		}
	}

	.remove-padding {
		margin-top: 1em	 !important;
		padding-top: 0 !important;
	}
		
</style>